var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"c59b5393c0778ef0ba97970a3a7ecf799d7c318d"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/flight/statics/vertical/c59b5393c0778ef0ba97970a3a7ecf799d7c318d";

import * as Sentry from '@sentry/nextjs';
import config, { getAppEnv } from 'config/index';

const { dsn, sampleRate } = config.sentry.flight;

Sentry.init({
  release: process.env.GIT_COMMIT_HASH || undefined,
  dsn,
  sampleRate,
  environment: getAppEnv(),
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: sampleRate,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/(?:[a-zA-Z0-9-]*-)?flight\.naver\.com/,
  ],
});
